import { Injectable } from "@angular/core";
import { Actions, Effect, ofType } from "@ngrx/effects";
import { catchError, map, switchMap } from "rxjs/operators";
import { Observable, of } from "rxjs";
import { KwikspaceService } from 'src/app/services/kwikspace.service';
import { GetBuildingsFailure, GetBuildingsSuccess, GetLocationsFailure, GetLocationsSuccess, GetOrganizationsFailure, GetOrganizationsSuccess, GetProvincesFailure, GetProvincesSuccess, GetSalesRepsFailure, GetSalesRepsSuccess, GetValiditiesFailure, GetValiditiesSuccess, KwikspaceActionTypes } from "../actions/kwikspace.action";

@Injectable()
export class KwikspaceEffects {
  public constructor(
    private actions$: Actions,
    private service: KwikspaceService
  ) { }

  @Effect()
  GetProvinces$: Observable<any> = this.actions$.pipe(
    ofType(KwikspaceActionTypes.GET_PROVINCES),
    switchMap((action: any) => {
      return this.service.getProvinces().pipe(
        map((res: any) => new GetProvincesSuccess(res)),
        catchError((error) => of(new GetProvincesFailure(error)))
      );
    })
  );

  @Effect()
  GetBuildings$: Observable<any> = this.actions$.pipe(
    ofType(KwikspaceActionTypes.GET_BUILDINGS),
    switchMap((action: any) => {
      return this.service.getBuildings().pipe(
        map((res: any) => new GetBuildingsSuccess(res)),
        catchError((error) => of(new GetBuildingsFailure(error)))
      );
    })
  );

  @Effect()
  GetOrganizations$: Observable<any> = this.actions$.pipe(
    ofType(KwikspaceActionTypes.GET_ORGANIZATIONS),
    switchMap((action: any) => {
      return this.service.getOrganizations().pipe(
        map((res: any) => new GetOrganizationsSuccess(res)),
        catchError((error) => of(new GetOrganizationsFailure(error)))
      );
    })
  );

  @Effect()
  GetLocations$: Observable<any> = this.actions$.pipe(
    ofType(KwikspaceActionTypes.GET_LOCATIONS),
    switchMap((action: any) => {
      return this.service.getSaleLocations().pipe(
        map((res: any) => new GetLocationsSuccess(res)),
        catchError((error) => of(new GetLocationsFailure(error)))
      );
    })
  );

  @Effect()
  GetValidities$: Observable<any> = this.actions$.pipe(
    ofType(KwikspaceActionTypes.GET_VALIDITIES),
    switchMap((action: any) => {
      return this.service.getQuoteValidities().pipe(
        map((res: any) => new GetValiditiesSuccess(res)),
        catchError((error) => of(new GetValiditiesFailure(error)))
      );
    })
  );

  @Effect()
  GetSalesReps$: Observable<any> = this.actions$.pipe(
    ofType(KwikspaceActionTypes.GET_SALES_REPS),
    switchMap((action: any) => {
      return this.service.getSalesReps().pipe(
        map((res: any) => new GetSalesRepsSuccess(res)),
        catchError((error) => of(new GetSalesRepsFailure(error)))
      );
    })
  );
}
